var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "filter-tag-" + _vm.filter.code,
      staticClass: "listing-table-filters__container"
    },
    [
      _c(
        "CompassDatePicker",
        _vm._b(
          {
            ref: "datepicker",
            attrs: {
              value: _vm.filter.datePickerValues,
              openCalendar: _vm.filter.displayDropdown
            },
            on: {
              close: function($event) {
                return _vm.updateVisibility(false)
              },
              "update:value": _vm.updateFilter,
              shortcutClicked: _vm.handleShortcutClick
            }
          },
          "CompassDatePicker",
          _vm.filter.filterConfig,
          false
        ),
        [
          _c("ListingTableFiltersTag", {
            ref: "datepickerTrigger",
            attrs: {
              type: _vm.filter.code,
              label: _vm.filter.activeLabel,
              valuesHumanized: _vm.filter.filterConfig.range
                ? _vm.labelTagRange
                : _vm.labelTagSingle
            },
            on: { removeFilter: _vm.removeFilter }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }